
import router from "@/router";
import {
  IonContent,
  IonPage,
  IonList,
  IonLabel,
  IonItem,
  IonTextarea,
  IonButton,
} from "@ionic/vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "Tandcs",
  components: {
    IonContent,
    IonPage,
    IonList,
    IonLabel,
    IonItem,
    IonTextarea,
    IonButton,
  },
  data() {
    return {
      tandcs: "",
    };
  },
  async mounted() {
    try {
      const text = await fetch("./assets/terms.txt");
      const realText = await text.text();
      this.tandcs = realText;
    } catch (e) {
      this.tandcs = "Error in text load " + e;
      console.log(this.tandcs);
    }
  },
  methods: {
    back() {
      router.back();
    },
  },
  computed: {},
});
